import { useEffect, useState } from "react";
import { getAllCompanies, getAllUsers } from "../api/request";
import DropdownMenu from "./DropdownMenu";

function AuthorityForm(props) {
    const [companiesID, setCompaniesID] = useState(null);
    const [companiesName, setCompaniesName] = useState(null);
    const [usersID, setUsersID] = useState(null);
    const [usersName, setUsersName] = useState(null);
    const [formData, setFormData] = useState(props.authority);

    const selectedIndexNoUser = (index) => {
        setFormData({ ...formData, userID: usersID[index] });
    };

    const selectedIndexNoCompany = (index) => {
        setFormData({ ...formData, companyID: companiesID[index] });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        props.onToggle(
            {
                userID: formData.userID,
                companyID: formData.companyID
            }
        );
    };

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await getAllUsers();
                const usersName = res.data.users.map(item => item.name + " " + item.surname);
                const usersID = res.data.users.map(item => item._id);
                setUsersName(usersName);
                setUsersID(usersID);
            } catch (error) {
                console.log(error);
            }
        };
        const fetchGateways = async () => {
            try {
                const res = await getAllCompanies();
                const companiesName = res.data.companies.map(item => item.name);
                const companiesID = res.data.companies.map(item => item._id);
                setCompaniesName(companiesName);
                setCompaniesID(companiesID);
            } catch (error) {
                console.log(error);
            }
        };
        fetchUsers();
        fetchGateways();
    }, []);

    return (
        <form
            onSubmit={handleSubmit}
            className='w-full flex flex-col md:flex-row'>
            <div className='w-full md:w-80 mr-0 md:mr-5'>
                <div className='flex flex-col mb-6'>
                    <label className='text-slate-600 font-medium mb-1'>Kullanıcı</label>
                    {
                        usersName
                            ? <DropdownMenu
                                selection={formData.userFullName}
                                selectedIndexNo={selectedIndexNoUser}
                                options={usersName} />
                            : ""
                    }

                </div>
                <div className='flex flex-col mb-6'>
                    <label className='text-slate-600 font-medium mb-1'>Firmalar</label>
                    {
                        companiesName
                            ? <DropdownMenu
                                selection={formData.companyName}
                                selectedIndexNo={selectedIndexNoCompany}
                                options={companiesName} />
                            : ""
                    }
                </div>
                <button
                    type="submit"
                    className='bg-blue-400 text-white px-4 py-2 rounded-lg hover:bg-blue-500'>
                    {props.buttonTitle}
                </button>
            </div>
        </form>
    )
}

export default AuthorityForm;